// @flow
import * as React from 'react';
import classNames from '@ta/common.classnames';
import BubbleRating from './BubbleRating';
import styles from './BubbleRatingWithLabel.css';

type Pixels = number;

type Props = {|
  /** the rating number multiplied by ten (i.e. for a 3.5 rating use 35). */
  rating: number,

  /** the font-size in px */
  fontSize: ?Pixels,

  /** label beside rating bubbles */
  label: React.Node,

  /** underline and change cursor to a pointer on mouse over */
  hoverable: boolean,

  /** bubble rating vertical align styles */
  bubbleRatingVerticalAlign: ?string,

  /** use stars instead of bubbles for affiliate reviews */
  useAffiliateStars: boolean,

  /** check to add filter specific style settings. See styles.bubbleRatingFilter */
  isFilterComponent?: boolean,
|};

/**
 * A bubble rating label.
 */
const BubbleRatingWithLabel = (props: Props) => (
  // the bubble rating gets cut off if we change the font size, but not the line height
  <div
    className={classNames(styles.poiReviewRating, {
      [styles.hoverable]: props.hoverable,
      [styles.bubbleRatingFilter]: props.isFilterComponent,
    })}
    style={
      props.fontSize && { fontSize: props.fontSize, lineHeight: props.fontSize > 14 ? 1.36 : 1.29 }
    }
  >
    <BubbleRating
      rating={props.rating}
      verticalAlign={props.bubbleRatingVerticalAlign}
      useAffiliateStars={props.useAffiliateStars}
    />
    {props.label}
  </div>
);

BubbleRatingWithLabel.defaultProps = {
  fontSize: null,
  hoverable: false,
  bubbleRatingVerticalAlign: null,
  useAffiliateStars: false,
};

export default BubbleRatingWithLabel;
